export const FETCH_HOMEPAGE = '@@homepage/FETCH_HOMEPAGE';
export const FETCH_HOMEPAGE_SUCCESS = '@@homepage/FETCH_HOMEPAGE_SUCCESS';
export const FETCH_HOMEPAGE_ERROR = '@@homepage/FETCH_HOMEPAGE_ERROR';
